import { useEffect } from 'react';
import useRequest from '@/websdk/utils/request';

export default (function (params) {
  const { data, exec, isRequestSuccessed } = useRequest({
    url: '',
    name: 'DEVICE_OEE_ANALYSIS_DETAIL_GET',
    manual: true,
  });

  useEffect(() => {
    if (params) {
      let url = `/api/device/oee/analysis/detail`;
      Object.keys(params).forEach((key, index) => {
        if (index === 0) {
          url += '?'
        } else {
          url += '&'
        };
        url += `${key}=${params[key]}`;
      });
      exec(url);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params]);

  return [data || {}, isRequestSuccessed];
});
